import { IconNameEnum } from "@b2bportal/core-themes";
import type { useI18nContext } from "@hopper-b2b/i18n";
import type { PerkspotUserInfoResponse } from "@/components/AuthModule/api/auth";

export interface Banner {
  name: string;
  location: string;
  row: string | number;
  position: string | number;
  eligibilityPayloadMapping: string;
  linkTarget: string;
  geoRestriction: string;
  logoFile: string;
  imageFile: string;
  tabBehavior: string;
  headerCopy: string;
  subheaderCopy: string;
  notes: string;
}

export interface PopularCategoriesItem {
  iconName: IconNameEnum;
  text: string;
  link: string;
  eligibilityPayloadMapping: string;
}

export const carsSectionBanners = {
  mainSection: [
    {
      name: "Avis HP Hero",
      location: "HP",
      row: "Cars Hero",
      position: 1,
      eligibilityPayloadMapping: "CarBrands - 289",
      linkTarget: "https://anything.perkspot.com/offer/1691005",
      geoRestriction: "None",
      logoFile: "Avis.png",
      imageFile: "Avis hero.png",
      tabBehavior: "change current tab",
      headerCopy: "Pay Now & Save 35%* + Enjoy a Free Double Class Upgrade",
      notes: "",
      brand: "Avis",
    },
    {
      name: "Budget HP Hero",
      location: "HP",
      row: "Cars Hero",
      position: 2,
      eligibilityPayloadMapping: "CarBrands - 121",
      linkTarget: "https://anything.perkspot.com/offer/1685123",
      geoRestriction: "None",
      logoFile: "Budget.svg",
      imageFile: "Budget hero.png",
      tabBehavior: "change current tab",
      headerCopy: "Up to 35% off Pay Now Rates + Up to 25% off Pay Later Rates",
      notes: "",
      brand: "Budget",
    },
  ],
  carouselSection: [
    {
      name: "Sixt HP Carousel",
      location: "HP",
      row: "Cars Carousel",
      position: 1,
      eligibilityPayloadMapping: "CarBrands - 47612",
      linkTarget: "https://anything.perkspot.com/offer/1698646",
      geoRestriction: "None",
      logoFile: "Sixt.png",
      imageFile: "sixt hero.webp",
      tabBehavior: "change current tab",
      headerCopy: "Up to 15% off Rental Base Rates",
      notes: "",
      brand: "Sixt",
    },
    {
      name: "Hertz HP Carousel",
      location: "HP",
      row: "Cars Carousel",
      position: 2,
      eligibilityPayloadMapping: "CarBrands - 358",
      linkTarget: "https://anything.perkspot.com/merchant/358",
      geoRestriction: "None",
      logoFile: "Hertz.svg",
      imageFile: "Hertz hero.png",
      tabBehavior: "change current tab",
      headerCopy: "Up to 20% saving every day",
      notes: "",
      brand: "Hertz",
    },
    {
      name: "Dollar HP Carousel",
      location: "HP",
      row: "Cars Carousel",
      position: 3,
      eligibilityPayloadMapping: "CarBrands - 1102",
      linkTarget: "https://anything.perkspot.com/merchant/1102",
      geoRestriction: "None",
      logoFile: "Dollar.png",
      imageFile: "dollar hero.webp",
      tabBehavior: "change current tab",
      headerCopy: "Up to 20% off Pay Later Car Rentals",
      notes: "",
      brand: "Dollar",
    },
    {
      name: "Thrifty HP Carousel",
      location: "HP",
      row: "Cars Carousel",
      position: 4,
      eligibilityPayloadMapping: "CarBrands - 1921",
      linkTarget: "https://anything.perkspot.com/merchant/1921",
      geoRestriction: "None",
      logoFile: "Thrifty.png",
      imageFile: "thrifty hero.webp",
      tabBehavior: "change current tab",
      headerCopy: "Up to 20% off Pay Later Rental Base Rates",
      notes: "",
      brand: "Thrifty",
    },
    {
      name: "Enterprise HP Carousel",
      location: "HP",
      row: "Cars Carousel",
      position: 5,
      eligibilityPayloadMapping: "CarBrands - 129",
      linkTarget: "https://anything.perkspot.com/merchant/129",
      geoRestriction: "None",
      logoFile: "Enterprise.svg",
      imageFile: "Enterprise hero.png",
      tabBehavior: "change current tab",
      headerCopy: "Everyday Low Rates With Enterprise",
      notes: "",
      brand: "Enterprise",
    },
    {
      name: "National HP Carousel",
      location: "HP",
      row: "Cars Carousel",
      position: 6,
      eligibilityPayloadMapping: "CarBrands - 285",
      linkTarget: "https://anything.perkspot.com/merchant/285",
      geoRestriction: "None",
      logoFile: "National.png",
      imageFile: "national hero.webp",
      tabBehavior: "change current tab",
      headerCopy: "Up to 25% off Car Rentals",
      notes: "",
      brand: "National",
    },
    {
      name: "Alamo HP Carousel",
      location: "HP",
      row: "Cars Carousel",
      position: 7,
      eligibilityPayloadMapping: "CarBrands - 792",
      linkTarget: "https://anything.perkspot.com/merchant/792",
      geoRestriction: "None",
      logoFile: "Alamo.png",
      imageFile: "Alamo hero.webp",
      tabBehavior: "change current tab",
      headerCopy: "Save on Your Next Pay Later Rental",
      notes: "",
      brand: "Alamo",
    },
    {
      name: "Turo HP Carousel",
      location: "HP",
      row: "Cars Carousel",
      position: 8,
      eligibilityPayloadMapping: "CarBrands - 44232",
      linkTarget: "https://anything.perkspot.com/merchant/44232",
      geoRestriction: "None",
      logoFile: "Turo.png",
      imageFile: "Turo hero.webp",
      tabBehavior: "change current tab",
      headerCopy: "Extra $25 off Any 3+ Day Car Rental",
      notes: "",
      brand: "Turo",
    },
  ],
} as const;

export const banners: Banner[] = [
  {
    name: "Disneyland Banner Confirmation Page",
    location: "Confirmation Page",
    row: "n/a",
    position: 1,
    eligibilityPayloadMapping: "Merchants - 51264",
    linkTarget: "https://anything.perkspot.com/pages/disneyland",
    geoRestriction: "California Zip Codes Only",
    logoFile: "Disneyland.png",
    imageFile: "none",
    tabBehavior: "new tab",
    headerCopy:
      "Up to $40 off per person on 2-5 day visits to the Disneyland® Resort.",
    subheaderCopy: "None",
    notes:
      "Park name must be formatted as Disneyland® Resort with rball and italics",
  },
  {
    name: "Disney World Banner Confirmation Page",
    location: "Confirmation Page",
    row: "n/a",
    position: 1,
    eligibilityPayloadMapping: "Merchants - 49323",
    linkTarget: "https://anything.perkspot.com/pages/walt-disney",
    geoRestriction: "Florida Zip Codes Only",
    logoFile: "Disney World.png",
    imageFile: "none",
    tabBehavior: "new tab",
    headerCopy:
      "Save up to $80 per person on Walt Disney World® Resort multi-day tickets.",
    subheaderCopy: "None",
    notes:
      "Park name must be formatted as Walt Disney World® Resort with rball and italics",
  },
  {
    name: "Universal Hollywood Banner Confirmation Page",
    location: "Confirmation Page",
    row: "n/a",
    position: 2,
    eligibilityPayloadMapping: "Merchants - 48253",
    linkTarget:
      "https://anything.perkspot.com/pages/universal-studios-hollywood",
    geoRestriction: "California Zip Codes Only",
    logoFile: "Universal Hollywood.png",
    imageFile: "none",
    tabBehavior: "new tab",
    headerCopy:
      "Picture your best day ever at Universal Studios Hollywood at the best price.",
    subheaderCopy: "None",
    notes: "",
  },
  {
    name: "Universal Orlando Banner Confirmation Page",
    location: "Confirmation Page",
    row: "n/a",
    position: 2,
    eligibilityPayloadMapping: "Merchants - 51969",
    linkTarget: "https://anything.perkspot.com/pages/universal-studios-florida",
    geoRestriction: "Florida Zip Codes Only",
    logoFile: "Universal Orlando.png",
    imageFile: "none",
    tabBehavior: "new tab",
    headerCopy:
      "Get up to $65 off per person on Multi-Day Visits to Universal Orlando Resort.",
    subheaderCopy: "None",
    notes: "",
  },
  {
    name: "Rental Cars Banner Confirmation Page",
    location: "Confirmation Page",
    row: "n/a",
    position: 3,
    eligibilityPayloadMapping: "Categories - 127",
    linkTarget: "https://anything.perkspot.com/pages/avis-budget-guide",
    geoRestriction: "None",
    logoFile: "Use Avis logo from HTS",
    imageFile: "none",
    tabBehavior: "new tab",
    headerCopy:
      "Get where you're going for less with exclusive deals on rental cars.",
    subheaderCopy: "None",
    notes: "",
  },
  {
    name: "Tickets Banner Confirmation Page",
    location: "Confirmation Page",
    row: "n/a",
    position: 4,
    eligibilityPayloadMapping: "Categories - 15",
    linkTarget: "https://anything.perkspot.com/tickets-attractions",
    geoRestriction: "None",
    logoFile: "Tickets and Attractions.png",
    imageFile: "none",
    tabBehavior: "new tab",
    headerCopy: "Save on theme parks, aquariums, museums, and more.",
    subheaderCopy: "None",
    notes: "",
  },
  {
    name: "Cruises Banner Confirmation Page",
    location: "Confirmation Page",
    row: "n/a",
    position: 5,
    eligibilityPayloadMapping: "Categories - 128",
    linkTarget: "https://anything.perkspot.com/category/128",
    geoRestriction: "None",
    logoFile: "perkspot-cruises-rgb-vertical.png",
    imageFile: "none",
    tabBehavior: "new tab",
    headerCopy: "Set sail with cruise deals you won't find elsewhere.",
    subheaderCopy: "None",
    notes: "",
  },
];

export const exploreFurtherBanners: Banner[] = [
  {
    name: "Flights Category Tile",
    location: "HP",
    row: "Explore Further",
    position: 1,
    eligibilityPayloadMapping: "Categories - 129",
    linkTarget: "https://anything.perkspot.com/category/129",
    geoRestriction: "None",
    logoFile: "None",
    imageFile: "Home-Page-Images-Flights.png",
    tabBehavior: "change current tab",
    headerCopy: "Flights",
    subheaderCopy: "Browse exclusive savings ready for takeoff.",
    notes: "",
  },
  {
    name: "Cruises Category Tile",
    location: "HP",
    row: "Explore Further",
    position: 2,
    eligibilityPayloadMapping: "Categories - 128",
    linkTarget: "https://anything.perkspot.com/category/128",
    geoRestriction: "None",
    logoFile: "None",
    imageFile: "Home-Page-Images-Cruises.png",
    tabBehavior: "change current tab",
    headerCopy: "Cruises",
    subheaderCopy: "Set sail with deals you won't find elsewhere.",
    notes: "",
  },
  {
    name: "Vacation Rentals Category Tile",
    location: "HP",
    row: "Explore Further",
    position: 3,
    eligibilityPayloadMapping: "Categories - 126",
    linkTarget: "https://anything.perkspot.com/category/126",
    geoRestriction: "None",
    logoFile: "None",
    imageFile: "Home-Page-Images-Vacation Rentals.png",
    tabBehavior: "change current tab",
    headerCopy: "Vacation Rentals",
    subheaderCopy:
      "Go beyond hotels with home-style stays and unique accommodations.",
    notes: "",
  },
  {
    name: "Rental Cars Category Tile",
    location: "HP",
    row: "Explore Further",
    position: 4,
    eligibilityPayloadMapping: "Categories - 127",
    linkTarget: "https://anything.perkspot.com/category/127",
    geoRestriction: "None",
    logoFile: "None",
    imageFile: "Home-Page-Images-Rental Cars.png",
    tabBehavior: "change current tab",
    headerCopy: "More Car Rental deals",
    subheaderCopy: "Get where you're going for less.",
    notes: "",
  },
];

export const completeYourTripBanners: Banner[] = [
  {
    name: "Tickets and Attractions Category Tile",
    location: "HP",
    row: "Complete Your Trip",
    position: 1,
    eligibilityPayloadMapping: "Categories - 15",
    linkTarget: "https://anything.perkspot.com/tickets-attractions",
    geoRestriction: "None",
    logoFile: "None",
    imageFile: "Home-Page-Images-Tickets & Attractions.png",
    tabBehavior: "change current tab",
    headerCopy: "Tickets & Attractions",
    subheaderCopy:
      "Discover deals on theme parks, aquariums, museums, and more.",
    notes: "",
  },
  {
    name: "Luggage Category Tile",
    location: "HP",
    row: "Complete Your Trip",
    position: 2,
    eligibilityPayloadMapping: "Categories - 130",
    linkTarget: "https://anything.perkspot.com/category/130",
    geoRestriction: "None",
    logoFile: "None",
    imageFile: "Home-Page-Images-Luggage.png",
    tabBehavior: "change current tab",
    headerCopy: "Luggage",
    subheaderCopy: "Pack your bags with confidence in your spending.",
    notes: "",
  },
  {
    name: "Tours and Activities Category Tile",
    location: "HP",
    row: "Complete Your Trip",
    position: 3,
    eligibilityPayloadMapping: "Categories - 270",
    linkTarget: "https://anything.perkspot.com/category/270",
    geoRestriction: "None",
    logoFile: "None",
    imageFile: "Home-Page-Images-Tours.png",
    tabBehavior: "change current tab",
    headerCopy: "Tours",
    subheaderCopy: "Save more on guided tours and experiences.",
    notes: "",
  },
  {
    name: "PerkSpot Live Tile",
    location: "HP",
    row: "Complete Your Trip",
    position: 4,
    eligibilityPayloadMapping: "Merchants - 44568",
    linkTarget: "https://anything.perkspot.com/pages/perkspot-live",
    geoRestriction: "None",
    logoFile: "None",
    imageFile: "Home-Page-Images-PerkSpot Live.png",
    tabBehavior: "change current tab",
    headerCopy: "PerkSpot Live",
    subheaderCopy:
      "Find tickets to live events you can't find anywhere else with our resale ticket marketplace.",
    notes: "",
  },
];

export const moreTravelSavingsBanners: Banner[] = [
  {
    name: "Hotels Category Tile",
    location: "HP",
    row: "More Travel Savings",
    position: 1,
    eligibilityPayloadMapping: "Categories - 125",
    linkTarget: "https://anything.perkspot.com/category/125",
    geoRestriction: "None",
    logoFile: "None",
    imageFile: "Home-Page-Images-Hotels.png",
    tabBehavior: "change current tab",
    headerCopy: "More Hotel deals",
    subheaderCopy: "Explore more ways to save on your stay.",
    notes: "",
  },
  {
    name: "Lodging Category Tile",
    location: "HP",
    row: "More Travel Savings",
    position: 2,
    eligibilityPayloadMapping: "Categories - 268",
    linkTarget: "https://anything.perkspot.com/category/268",
    geoRestriction: "None",
    logoFile: "None",
    imageFile: "Home-Page-Images-Lodging.png",
    tabBehavior: "change current tab",
    headerCopy: "Lodging",
    subheaderCopy:
      "Planning a weekend getaway? Spend less on your accomodation.",
    notes: "",
  },
  {
    name: "Parking Category Tile",
    location: "HP",
    row: "More Travel Savings",
    position: 3,
    eligibilityPayloadMapping: "Categories - 131",
    linkTarget: "https://anything.perkspot.com/category/131",
    geoRestriction: "None",
    logoFile: "None",
    imageFile: "Home-Page-Images-Airport Parking & Transportation.png",
    tabBehavior: "change current tab",
    headerCopy: "Parking & Transportation",
    subheaderCopy: "Find the perfect spot without breaking the bank.",
    notes: "",
  },
  {
    name: "Travel Agencies Category Tile",
    location: "HP",
    row: "More Travel Savings",
    position: 4,
    eligibilityPayloadMapping: "Categories - 194",
    linkTarget: "https://anything.perkspot.com/category/194",
    geoRestriction: "None",
    logoFile: "None",
    imageFile: "Home-Page-Images-Travel Agencies.png",
    tabBehavior: "change current tab",
    headerCopy: "Travel Agencies",
    subheaderCopy:
      "Expert help curating the vacation you've been dreaming about.",
    notes: "",
  },
];

export const myTripsBanners: Banner[] = [
  {
    name: "Disneyland Banner My Trips",
    location: "My Trips",
    row: "n/a",
    position: 1,
    eligibilityPayloadMapping: "Merchants - 51264",
    linkTarget: "https://anything.perkspot.com/pages/disneyland",
    geoRestriction: "California Zip Codes Only",
    logoFile: "Disneyland.png",
    imageFile: "none",
    tabBehavior: "new tab",
    headerCopy:
      "Up to $40 off per person on 2-5 day visits to the Disneyland® Resort.",
    subheaderCopy: "None",
    notes:
      "Park name must be formatted as Disneyland® Resort with rball and italics",
  },
  {
    name: "Disney World Banner My Trips",
    location: "My Trips",
    row: "n/a",
    position: 1,
    eligibilityPayloadMapping: "Merchants - 49323",
    linkTarget: "https://anything.perkspot.com/pages/walt-disney",
    geoRestriction: "Florida Zip Codes Only",
    logoFile: "Disney World.png",
    imageFile: "none",
    tabBehavior: "new tab",
    headerCopy:
      "Save up to $80 per person on Walt Disney World® Resort multi-day tickets.",
    subheaderCopy: "None",
    notes:
      "Park name must be formatted as Walt Disney World® Resort with rball and italics",
  },
  {
    name: "Universal Hollywood Banner My Trips",
    location: "My Trips",
    row: "n/a",
    position: 2,
    eligibilityPayloadMapping: "Merchants - 48253",
    linkTarget:
      "https://anything.perkspot.com/pages/universal-studios-hollywood",
    geoRestriction: "California Zip Codes Only",
    logoFile: "Universal Hollywood.png",
    imageFile: "none",
    tabBehavior: "new tab",
    headerCopy:
      "Picture your best day ever at Universal Studios Hollywood at the best price.",
    subheaderCopy: "None",
    notes: "",
  },
  {
    name: "Universal Orlando Banner My Trips",
    location: "My Trips",
    row: "n/a",
    position: 2,
    eligibilityPayloadMapping: "Merchants - 51969",
    linkTarget: "https://anything.perkspot.com/pages/universal-studios-florida",
    geoRestriction: "Florida Zip Codes Only",
    logoFile: "Universal Orlando.png",
    imageFile: "none",
    tabBehavior: "new tab",
    headerCopy:
      "Get up to $65 off per person on Multi-Day Visits to Universal Orlando Resort.",
    subheaderCopy: "None",
    notes: "",
  },
  {
    name: "Rental Cars Banner My Trips",
    location: "My Trips",
    row: "n/a",
    position: 3,
    eligibilityPayloadMapping: "Categories - 127",
    linkTarget: "https://anything.perkspot.com/pages/avis-budget-guide",
    geoRestriction: "None",
    logoFile: "Use Avis logo from HTS",
    imageFile: "none",
    tabBehavior: "new tab",
    headerCopy:
      "Get where you're going for less with exclusive deals on rental cars",
    subheaderCopy: "None",
    notes: "",
  },
  {
    name: "Tickets Banner My Trips",
    location: "My Trips",
    row: "n/a",
    position: 4,
    eligibilityPayloadMapping: "Categories - 15",
    linkTarget: "https://anything.perkspot.com/tickets-attractions",
    geoRestriction: "None",
    logoFile: "Tickets and Attractions.png",
    imageFile: "none",
    tabBehavior: "new tab",
    headerCopy: "Save on theme parks, aquariums, museums, and more.",
    subheaderCopy: "None",
    notes: "",
  },
  {
    name: "Cruises Banner My Trips",
    location: "My Trips",
    row: "n/a",
    position: 5,
    eligibilityPayloadMapping: "Categories - 128",
    linkTarget: "https://anything.perkspot.com/category/128",
    geoRestriction: "None",
    logoFile: "perkspot-cruises-rgb-vertical.png",
    imageFile: "none",
    tabBehavior: "new tab",
    headerCopy: "Set sail with cruise deals you won't find elsewhere.",
    subheaderCopy: "None",
    notes: "",
  },
];

export const popularCategories = (
  t: ReturnType<typeof useI18nContext>["t"]
): PopularCategoriesItem[] => [
  {
    iconName: IconNameEnum.homepagePerkHealth,
    text: t("home.perks.health"),
    link: "https://anything.perkspot.com/category/9",
    eligibilityPayloadMapping: "Categories - 9",
  },
  {
    iconName: IconNameEnum.homepagePerkFood,
    text: t("home.perks.food"),
    link: "https://anything.perkspot.com/category/8",
    eligibilityPayloadMapping: "Categories - 8",
  },
  {
    iconName: IconNameEnum.homepagePerkApparel,
    text: t("home.perks.apparel"),
    link: "https://anything.perkspot.com/category/1",
    eligibilityPayloadMapping: "Categories - 1",
  },
  {
    iconName: IconNameEnum.homepagePerkAutomotive,
    text: t("home.perks.automotive"),
    link: "https://anything.perkspot.com/category/2",
    eligibilityPayloadMapping: "Categories - 2",
  },
  {
    iconName: IconNameEnum.homepagePerkTravel,
    text: t("home.perks.travel"),
    link: "https://travel.perkspot.com",
    eligibilityPayloadMapping: "Categories - 125",
  },
  {
    iconName: IconNameEnum.homepagePerkAuto,
    text: t("home.perks.auto"),
    link: "https://anything.perkspot.com/category/299",
    eligibilityPayloadMapping: "Categories - 299",
  },
  {
    iconName: IconNameEnum.homepagePerkElectronic,
    text: t("home.perks.electronic"),
    link: "https://anything.perkspot.com/category/5",
    eligibilityPayloadMapping: "Categories - 5",
  },
  {
    iconName: IconNameEnum.homepagePerkOutdoors,
    text: t("home.perks.outdoors"),
    link: "https://anything.perkspot.com/category/14",
    eligibilityPayloadMapping: "Categories - 14",
  },
];

export function matchEligibility(
  userDetails: PerkspotUserInfoResponse | undefined,
  eligibilityPayloadMapping: string
): boolean {
  let match: RegExpMatchArray | null = null;
  const eligibility = userDetails?.eligibility;

  if ((match = eligibilityPayloadMapping.match(/Merchants - (\d+)/)) != null) {
    // Merchants are not gated by eligibility criteria yet
    return true;
  }
  if ((match = eligibilityPayloadMapping.match(/CarBrands - (\d+)/)) != null) {
    const brandId = parseInt(match[1], 10);
    return (
      eligibility?.carBrands?.some((brand) => brand.id === brandId) ?? false
    );
  }
  if ((match = eligibilityPayloadMapping.match(/Categories - (\d+)/)) != null) {
    const categoryId = parseInt(match[1], 10);
    return (
      eligibility?.categories?.some((category) => category.id === categoryId) ??
      false
    );
  }
  return false;
}
